module.exports = __webpack_public_path__ + "static/media/etisalat.f346da1d.png";